import { render, staticRenderFns } from "./FacturaComponent.vue?vue&type=template&id=f67f12d2&"
import script from "./FacturaComponent.vue?vue&type=script&lang=js&"
export * from "./FacturaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports